module.exports = __webpack_public_path__ + "media/images/arrow_back-d08b9f7b42f2c23d808bcafd4134ff69.png";